// useConfiguration.js
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import useHandleErrors from "./user.utils";
import { toast } from "react-toastify";

const useConfiguration = () => {
  const [config, setConfig] = useState(null);
  const token = localStorage.getItem("token");
  const handleErrors = useHandleErrors();
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const path = "/getConfigurationCenter";
        const URL = process.env.REACT_APP_BE_URL + path;
        const response = await axios.get(URL, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200) {
          setConfig(response.data);
        } else {
          handleErrors(response);
        }
      } catch (error) {
        console.error("Error fetching configuration:", error);
        if (error.response) {
          handleErrors(error.response);
        } else {
          toast.error("Something went wrong. Please try again later.", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    };

    if (!config) {
      if (!hasFetchedRef.current) {
        fetchConfig();
        hasFetchedRef.current = true;
    }
    }
  }, [config]);

  return config;
};

export default useConfiguration;
